import React, { useEffect, useState, useCallback } from "react";
import Ping from "ping.js";

const App = () => {
  const [results, setResults] = useState([]);
  const [fastest, setFastest] = useState(null);
  const [shouldPing, setShouldPing] = useState(true);
  const [loading, setLoading] = useState(false);

  const urls = [
    "https://na.lightwalletd.com:443",
    "https://sa.lightwalletd.com:443",
    "https://eu.lightwalletd.com:443",
    "https://ai.lightwalletd.com:443",
  ];

  const pingServers = useCallback(() => {
    let pings = [];

    urls.forEach((url) => {
      let p = new Ping();

      p.ping(url)
        .then(data => {
          let obj = { url, latency: data + "ms" };
          pings.push(obj);

          if (pings.length === urls.length) {
            pings.sort((a, b) => parseFloat(a.latency) - parseFloat(b.latency));
            setFastest(pings[0]);
            setResults(pings);
            setLoading(false);
          }
        })
        .catch(err => {
          let obj = { url, latency: err + "ms" };
          pings.push(obj);

          if (pings.length === urls.length) {
            pings.sort((a, b) => parseFloat(a.latency) - parseFloat(b.latency));
            setResults(pings);
            setFastest(pings.find(ping => !isNaN(parseFloat(ping.latency))));
            setLoading(false);
          }
        });
    });
  }, [urls]);

  useEffect(() => {
    if (shouldPing) {
      setLoading(true);
      setResults([]);
      setFastest(null);
      pingServers();
      setShouldPing(false);
    }
  }, [shouldPing, pingServers]);

  const handleClick = () => {
    setShouldPing(true);
  };

  //...

  return (
    <div className="min-h-screen bg-black text-green-400 px-4 py-6">
      <h1 className="text-2xl font-mono mb-4">Ping Test</h1>
      <div className="bg-black border-green-600 border rounded-lg p-4 mb-6 text-sm font-mono">
        <h2 className="mb-2">
          Fastest Server:
          {fastest && <div>Host: {new URL(fastest.url).hostname}, Port: 443</div>}
          {fastest && <div>Latency: {fastest.latency}</div>}
        </h2>
        {loading ? <div className="h-2 bg-green-700 rounded" /> : null}
        {results.map((result, index) => (
          <p key={index}>
            Host: {new URL(result.url).hostname}, Port: 443: {result.latency}
          </p>
        ))}
      </div>
      <button
        onClick={handleClick}
        className="bg-green-700 hover:bg-green-800 text-white font-mono py-2 px-4 rounded">
        Ping again
      </button>
    </div>
  );
};

export default App;

